export default {
  referral: [],
  referralColumns:null,
  referralMeta:null,
}